// extracted by mini-css-extract-plugin
export var inline = "_v3-0";